import React from 'react'
import {AutoComplete, Form, Input, Select} from "antd";
import config from "../../../config";

const {Option} = AutoComplete


const DispatchFilter = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'customerName'}
                label={'Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'dispatchNo'}
                label={'İrsaliye No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'shipmentStatus'}
                label={'Sevk Durumu'}
                initialValue={''}
                rules={[{required: true, message: 'Bu Alan Zorunludur'}]}
            >
                <Select>
                    {
                        config.shippingStatus.map((item, index) => <Option key={index} value={item.key}>{item.text}</Option>)
                    }
                </Select>
            </Form.Item>
        </React.Fragment>
    )
}

export default DispatchFilter